import styled from "styled-components";

import {
  PRIMARY_COLOR,
  TEXT_LIGHT_COLOR,
  QUERY_IPAD,
  QUERY_IPHONE_6_7_8_PLUS,
  QUERY_IPHONE_6_7_8,
  QUERY_IPHONE_5,
} from "@shared/constants";

export const StyledLandingSection = styled.section`
  position: relative;
  height: 100vh;
  background-color: ${PRIMARY_COLOR};
  overflow: hidden;
  z-index: 5; // For navbar

  .content {
    position: relative;
    height: 100%;
    max-width: 1000px;
    margin: auto;
    padding: 0 30px;
  }

  .intro {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 2;
    pointer-events: none;

    .title {
      font-size: 72px;
      color: ${TEXT_LIGHT_COLOR};
      white-space: nowrap;
    }

    .divider {
      width: 168px;
      height: 1px;
      background-color: #7e7e7e;
      margin: 40px 0;
    }

    .sub-title {
      font-size: 24px;
      color: ${TEXT_LIGHT_COLOR};
    }
  }

  .shuttle-container {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 50%;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    .center {
      position: absolute;
      left: 50%;
      transform: translate(-50%, 0);
    }

    .shuttle {
      z-index: 500;

      .core {
        position: relative;
        z-index: 3;
      }

      .trail {
        background-color: #a8dadc;
        border-radius: 20px;
        width: 18px;
        position: absolute;
      }

      .trail-back {
        opacity: 0.4;
      }

      .trails {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;

        // Left
        .trail-1 {
          top: -20px;
          left: 5px;
          height: 122px;
        }

        .trail-2 {
          top: 20px;
          left: 60px;
          height: 156px;
        }

        .trail-3 {
          top: -70px;
          left: 102px;
          height: 120px;
        }

        .trail-3-drop {
          top: 60px;
          left: 102px;
          height: 23px;
        }

        // Center
        .trail-4 {
          top: 16px;
          left: 50%;
          transform: translateX(-50%);
          height: 103px;
        }

        .trail-4-drop {
          top: 130px;
          left: 50%;
          transform: translateX(-50%);
          height: 42px;
        }

        // Right
        .trail-5 {
          top: -70px;
          right: 102px;
          height: 80px;
        }

        .trail-6 {
          top: 40px;
          right: 60px;
          height: 160px;
        }

        .trail-7 {
          top: 0px;
          right: 5px;
          height: 130px;
        }
      }
    }

    .circle {
      background-color: #ffffff;
      border-radius: 50%;
      opacity: 0.05;
      transition: opacity 0.5s;

      &:hover {
        opacity: 0.1 !important;
      }
    }
  }

  @media (max-width: ${QUERY_IPAD}px) {
    .intro {
      .title {
        font-size: 56px;
      }

      .sub-title {
        font-size: 16px;
      }
    }

    .shuttle-container {
      transform: scale(0.85, 0.85);
    }
  }

  @media (max-width: 630px) {
    .intro {
      display: flex;
      flex-direction: column;
      align-items: center;
      top: auto;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, -50%);

      .title {
        font-size: 36px;
      }

      .divider {
        margin: 20px 0;
        width: 90px;
      }
    }

    .shuttle-container {
      left: 0;
      top: -370px;
      transform: scale(0.8, 0.8);
    }
  }

  @media (max-width: ${QUERY_IPHONE_6_7_8_PLUS}px) {
    .shuttle-container {
      transform: scale(0.7, 0.7);
    }
  }

  @media (max-width: ${QUERY_IPHONE_6_7_8}px) {
    .shuttle-container {
      top: -340px;
      transform: scale(0.6, 0.6);
    }
  }

  @media (max-width: ${QUERY_IPHONE_5}px) {
    .shuttle-container {
      top: -300px;
      transform: scale(0.45, 0.45);
    }
  }
`;
